import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  test: any;
  constructor(private router: Router) { }

  ngOnInit(): void {

    const toggleButton = document.getElementsByClassName('toggle-button')[0];
    const navbarLinks = document.getElementsByClassName('navbar-links')[0];
    toggleButton.addEventListener('click', () => {
      navbarLinks.classList.toggle('active');
    });
  }

  redirecttoHome() {
    this.router.navigate(['/home']);
  }

  navigatecontact() {
    this.router.navigate(['contact']);
  }
  navigateblog() {
    this.router.navigate(['blog']);
  }
  navigatelevelmonitoring() {
    this.router.navigate(['levelmonitoring']);
  }
  navigateflowmonitoring() {
    this.router.navigate(['flowmonitoring']);
  }
  navigateiiotsoftwareplatform() {
    this.router.navigate(['iiotsoftwareplatform']);
  }

  navigatepredictivemaitainance() {
    this.router.navigate(['predictivemaintainance']);
  }

  navigateabout() {
    this.router.navigate(['about-us']);
  }

  navigateenergymonitoring() {
    this.router.navigate(['energymonitoring']);
  }
}
